export default __webpack_public_path__ + "static/O0298-f41b38db47a984c4a3b8622914b64a30.png";